import { GlobalHeaderState, SwgyHeaderKeysList } from "@swiggy-private/checkout-core";

const BHARAT_MANDAPAM_CITY_ID = "10874";

export const isBharatMandapamCity = (): boolean => {
    const cityId = GlobalHeaderState.getHeader(SwgyHeaderKeysList.cityid);
    return cityId === BHARAT_MANDAPAM_CITY_ID;
};
